import {
  Button,
  Card,
  CardBody,
  CardFooter,
  FormControl,
  FormLabel,
  Heading,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { UserAuth } from "../../auth/AuthContext";

const UserProfile = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const { user, userRef, PasswordReset } = UserAuth();
  const [email] = useState(user ? user.email : null);
  const [submit, setSubmit] = useState(false);

  const resetPass = () => {
    setSubmit(true);
    PasswordReset(email)
      .then(() => {
        setSubmit(false);
        onClose();
        toast({
          title: `E-mail enviado! verifique no lixo eletrônico também.`,
          status: "success",
          isClosable: true,
        });
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        toast({
          title: errorMessage,
          status: "error",
          isClosable: true,
        });

        // ..
      });
  };

  return (
    <Card
      direction={{ base: "column", sm: "row" }}
      overflow="hidden"
      variant="outline"
    >
      <Image
        objectFit="cover"
        maxW={{ base: "100%", sm: "200px" }}
        src="https://images.unsplash.com/photo-1667489022797-ab608913feeb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw5fHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=800&q=60"
        alt="Caffe Latte"
      />

      <Stack>
        <CardBody>
          {userRef.name ? (
            <Heading size="md" py="3">
              OLÁ {userRef.name}
            </Heading>
          ) : null}

          <Text py="1">
            Seu Usuário é: {user.displayName ? user.displayName : null}
          </Text>
          <Text py="1">Seu E-mail de acesso é: {user ? user.email : null}</Text>
          <Text py="1">Seu ID é: {user ? user.uid : null}</Text>
          <Text py="1">
            {userRef.filial ? `Sua Filial é: ${userRef.filial}` : null}
          </Text>
        </CardBody>

        <CardFooter>
          <Button onClick={onOpen} colorScheme="blue">
            Redefinir senha
          </Button>

          <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Redefinir senha</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <Text>{email}</Text>
              </ModalBody>

              <ModalFooter>
                <Button onClick={onClose} mr={3}>
                  Cancel
                </Button>
                {submit ? (
                  <Button
                    isLoading
                    loadingText="Enviando..."
                    colorScheme="green"
                    variant="outline"
                  >
                    Submit
                  </Button>
                ) : (
                  <Button colorScheme="blue" onClick={resetPass}>
                    Enviar
                  </Button>
                )}
              </ModalFooter>
            </ModalContent>
          </Modal>
        </CardFooter>
      </Stack>
    </Card>
  );
};

export default UserProfile;
